import { Link, NavLink } from "react-router-dom";

import useScrollProgress from "../hooks/useScrollProgress";
import useAnchorNav from "../hooks/useAnchorNav";
import useI18n from "../i18n/useI18n";
import LanguageToggle from "./shared/LanguageToggle";
import { pageLinks, anchorLinks, aiCta } from "../data/navConfig";
import logo from "../assets/images/white logo.png";

const HeaderComponent = ({ isMenuOpen, toggleOpenNavMenu }) => {
  const { scrolled } = useScrollProgress();
  const navigateToHash = useAnchorNav();
  const { t } = useI18n();

  const handleAnchor = (event, id) => {
    event.preventDefault();
    navigateToHash(id);
  };

  return (
    <header className={`site-header${scrolled ? " is-scrolled" : ""}`}>
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand" aria-label="CodeIL">
          <img src={logo} alt="CodeIL" />
        </Link>

        <nav className="site-header__nav" aria-label={t("nav.primary")}>
          {pageLinks.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              className={({ isActive }) => `site-header__link${isActive ? " is-active" : ""}`}
            >
              {t(item.labelKey)}
            </NavLink>
          ))}
          {anchorLinks.map((item) => (
            <a
              key={item.id}
              href={item.hash}
              className="site-header__link"
              onClick={(event) => handleAnchor(event, item.id)}
            >
              {t(item.labelKey)}
            </a>
          ))}
        </nav>

        <div className="site-header__actions">
          <LanguageToggle />
          <a
            href={aiCta.hash}
            className="site-header__cta"
            onClick={(event) => handleAnchor(event, aiCta.id)}
          >
            <span className="site-header__cta-dot" aria-hidden="true" />
            {t(aiCta.labelKey)}
          </a>
        </div>

        <button
          type="button"
          className="site-header__burger"
          aria-label={t("nav.menu")}
          aria-expanded={Boolean(isMenuOpen)}
          aria-controls="mobile-drawer"
          onClick={() => toggleOpenNavMenu(!isMenuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default HeaderComponent;
